import { makeStyles } from '@material-ui/styles';

const EMPTY_SPACE_WIDTH = 40;

export default makeStyles(theme => ({
  menu: {
    backdropFilter: 'blur(8px)',
    '& > div:first-child': {
      backgroundColor: 'transparent',
    },
  },
  panel: {
    width: `calc(100% - ${EMPTY_SPACE_WIDTH}px)`,
    boxShadow: `inset 1px 0px 0px rgba(0, 0, 0, 0.16)`,
    maxWidth: 500,
  },
  topBar: {
    height: theme.spacing(8),
    padding: [0, 12],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: `inset 0px -1px 0px rgba(0, 0, 0, 0.16)`,
    width: '100%',
  },
  content: {
    width: '100%',
    padding: [0, theme.spacing(3), theme.spacing(3)],
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  socialButtons: {
    marginTop: 'auto',
  },
  nav: {
    padding: [theme.spacing(4), 0, 12],
    borderBottom: [1, 'solid', theme.palette.colors.lightGraySecondary],
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      flexDirection: 'row',
      padding: 0,
      borderBottom: 'none',
    },
  },
  navItem: {
    padding: [12, 0],
    width: 'auto',
    [theme.breakpoints.up('mobile')]: {
      padding: 0,
      marginRight: theme.spacing(4),
      '&:last-child': {
        marginRight: 0,
      },
    },
  },
  navLink: {
    color: theme.palette.colors.darkBlue,
    fontSize: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      color: theme.palette.colors.black,
      fontWeight: '700',
      '&:focus': {
        textDecoration: 'none',
        color: theme.palette.colors.black,
      },
    },
  },
  topItem: {
    width: '100%',
    height: 34,
    fontSize: theme.spacing(2),
    display: 'flex',
    marginBottom: 12,
    padding: 0,
  },
  topItemLink: {
    display: 'flex',
    height: '100%',
    width: '100%',
    color: theme.palette.colors.white,
    backgroundColor: theme.palette.colors.teal,
    borderRadius: 4,
    fontWeight: '700',
    padding: [0, 7],
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      color: theme.palette.colors.white,
    },
    '&:focus': {
      color: theme.palette.colors.white,
      textDecoration: 'none',
    },
  },
  topItemLinkSecondary: {
    border: [1, 'solid', theme.palette.colors.teal],
    backgroundColor: theme.palette.colors.white,
    color: theme.palette.colors.teal,
    '&:hover': {
      color: theme.palette.colors.teal,
    },
    '&:focus': {
      color: theme.palette.colors.teal,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MobileNonAuthHeader/components/SideBar/useStyles.js